var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"main-content"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('keep-alive',[_vm._t("default",function(){return [_c('router-view')]})],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }